import { WORKSHOP_COPY, WORKSHOP_CREATE, WORKSHOP_DELETE, WORKSHOP_LIST, WORKSHOP_UPDATE, WORKSHOP_VIEW } from "config/apiPaths"
import { baseApi } from "utils/axios/baseApi";

export const workshop = baseApi.injectEndpoints({
    endpoints: (builder) => ({

        // create note
        createWorkshop: builder.mutation({
            query: ({ data }) => ({
                method: "POST",
                url: WORKSHOP_CREATE,
                data
            }),
            invalidatesTags: ["workshopList"]
        }),

        // update note
        updateWorkshop: builder.mutation({
            query: ({ data, workshopId }) => ({
                method: "PUT",
                url: `${WORKSHOP_UPDATE}/${workshopId}`,
                data
            }),
            invalidatesTags: ["workshopList", "workshopDetail"]
        }),

        getWorkshops: builder.query({
            query: ({ page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: WORKSHOP_LIST,
                data: { page, limit, sort }
            }),
            providesTags: ["workshopList"],
            transformResponse: (response) => {
                return response.data;
            },
        }),

        workshopView: builder.query({
            query: ({ workshopId }) => ({
                method: "GET",
                url: `${WORKSHOP_VIEW}/${workshopId}`,
            }),
            providesTags: ["workshopDetail"],
            transformResponse: (response) => {
                return response.data;
            },
        }),

        // delete note
        deleteWorkshop: builder.mutation({
            query: ({ workshopId }) => ({
                method: "DELETE",
                url: `${WORKSHOP_DELETE}/${workshopId}`
            }),
            invalidatesTags: ["workshopList"]
        }),

        copyWorkshop: builder.mutation({
            query: ({ workshopId, screening_date }) => ({
                method: "GET",
                url: `${WORKSHOP_COPY}/${workshopId}/${screening_date}`
            }),
            invalidatesTags: ["workshopList"]
        }),


    }),
})

export const {
    useCreateWorkshopMutation,
    useUpdateWorkshopMutation,
    useGetWorkshopsQuery,
    useWorkshopViewQuery,
    useDeleteWorkshopMutation,
    useCopyWorkshopMutation
} = workshop;